exports.en = {
  UNIFORM_DETAIL: {
    INVALID_RADIO: 'Please choose.'
  }
}
